// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__ONgJy","delete":"styles_delete__1WVOx","update":"styles_update__1IFmf","add":"styles_add__whuct"};